/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth, UserRole } from '../modules/auth'
import { App } from '../App'
import Apresentacao from '../modules/apresentacao/Apresentacao'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  const { currentUser } = useAuth()

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='apresentacao' element={<Apresentacao />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to={
                (function() {
                  const roles = currentUser?.role;
                  if (!roles || roles.length === 0) return '/home';
                  const role = roles[0];
                  switch (role) {
                    case UserRole.ADMINISTRATOR: return '/home';
                    case UserRole.MANAGER:
                    case UserRole.CONSULTOR:
                    case UserRole.REVIEWER:
                    case UserRole.ARTICULATOR: return '/articulador';
                    case UserRole.TEACHER: return '/professor';
                    default: return '/home';
                  }
                })()
              } />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
